export default {"src":"/_next/static/media/ico_capture.3ac2a186.svg","height":42,"width":44,"blurWidth":0,"blurHeight":0};